import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
                // Base State: Standard thin border
                "h-10 flex w-full rounded-md border border-border bg-transparent px-4 text-sm outline-none transition-all duration-200",
                
                // Focus State: Keep border-1 but add a ring to simulate thickness
                "focus-visible:border-foreground focus-visible:ring-[1px] focus-visible:ring-foreground",
                
                // States & Accessibility
                "placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
                className
              )}
      {...props}
    />
  )
}

export { Input }
